import { ReviewsScreen } from './reviews-screen'

export { ReviewsScreen }